import printers from 'src/redux/reducers/printers';
import printersAssignments from 'src/redux/reducers/printersAssignments';
import deliveryEvents from 'src/redux/reducers/deliveryEvents';

export default {
  printers,
  printersAssignments,
  deliveryEvents,
};
